import $http from "../../assets/js/request";

const apiObj = {
  getImUser: "im/users/systemUser", //获取im客服信息
  postFriendAdd: "im/friends/add", //添加好友
  getMessageList: "im/messages", //获取聊天记录
  getMessagePage: "im/messages/page",
};

export const getImUser = (params) => {
  return $http.get(apiObj.getImUser, { params });
};

export const getMessageList = (params) => {
  return $http.get(apiObj.getMessageList, { params });
};

export const getMessagePage = (params) => {
  return $http.get(apiObj.getMessagePage, { params });
};
